import React, { Component } from 'react';
import sortBy from 'lodash/sortBy';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import triangleShape from '../../../../assets/triangle-shape.svg';
import orderBy from 'lodash/orderBy';

class OrgChartNode extends Component {

  handleNodeClick = (node) => {
    // console.log(node)
    this.props.onNodeClick(node);
  }

  // componentWillMount() {
  //   this.props.onNodeClick(this.props.node);
  // }

  // componentDidMount() {
  //   if(this.props.node && !isEmpty(this.props.node)) {
  //     this.props.onNodeClick(this.props.node);
  //   }
  // }

  render() { 
    // console.log('heyprops', this.props);
    const {path,name,title,docs,isChild,isParent,employeeCount,isLeafNode,kpi} = this.props.node;
    const {drillDownLevel,allKpis,selectedOffice,kpiType} = this.props;
    console.log(this.props.node, this.props)
    let officeName = '';
    if(title && title.length>0){
      officeName= title
    }else if (name) {
      officeName=name
    }else if (path) {
      officeName = path.split("#").slice(-1).pop();
    }

    const isSelectedOffice = officeName === selectedOffice;
    const showHeader = ( drillDownLevel > 0 ) && isParent;
    // console.log(allKpis);
    return ( 
      <div>
        <div 
          className="org-chart-drill-up" 
          onClick={() => this.props.onDrillUpClick(this.props.node)}
          style={{display : showHeader ? 'block' : 'none',borderColor:isSelectedOffice?'#1EC4B4':'#C3C4C7'}}>
          DRILL UP ONE LEVEL <img src={triangleShape} style={{ marginTop:'-2px',transform: 'rotate(180deg)'}} />
        </div>
        <div className="org-chart-node" 
          style={{width:'170px',margin:'auto',borderColor:isSelectedOffice?'#1EC4B4':'#C3C4C7'}} 
          onClick={() => this.handleNodeClick(this.props.node)}>
            <div 
              className="org-chart-node-header"
              style={{borderColor:isSelectedOffice?'#1EC4B4':'#C3C4C7',
                color:isSelectedOffice ? '#FFFFFF' : '#5099DE',
                background : isSelectedOffice ? '#1EC4B4' : '#EDF9FF'}}>
              {officeName}
              <br/>
              {/* <span  className="org-chart-node">
                {employeeCount ? employeeCount : 0} Total Employees
              </span> */}
            </div>
            
            <div 
              className="org-chart-node-body"
              style={{borderColor:isSelectedOffice?'#1EC4B4':'#C3C4C7'}}>
            
              {
                kpiType === "SURVEY_BASED" ? 
                kpi ? 
                kpi.map((o,i) => {
                  const kpiCode = Object.keys(o)[Object.keys(o).length - 1];
                  //{Math.round(o[kpiCode][0].score.toFixed(1))}
                  return(
                    <div key={i}>
                      <span> KPI {i+1}: </span>
                      {
                       
                        o[kpiCode] && o[kpiCode].length > 0 ?
                        <span>{o[kpiCode][0].score.toFixed(1)}</span> 
                        :
                        <span>No Score Available</span>
                      }
                    </div>
                  )
                }) : null
                :
                kpi ? 
                kpi.map((o,i) => {
                  const sortedKpiAggregate= orderBy(o, ['isoDate'],['desc'])
                  //{Math.round(sortedKpiAggregate[0].score.toFixed(1))} %
                  return(
                    <div key={i}>
                    {
                      <span>
                        {
                          `KPI ${i+1}: `
                        } 
                        {
                          o.length > 0 ? 
                          <span>
                            {Math.round(sortedKpiAggregate[0].score)} %
                          </span>
                          :
                          <span>No Score Available</span>
                        }
                      </span>
                    }
                    </div>
                  )
                }) : null
              }
            </div>
          <div className="overlay overlay-text">
            Show analytics for this office
          </div>
        </div>
        <div className="org-chart-node-footer" 
          style={{display:isChild ? 'block' : 'none',borderColor:isSelectedOffice?'#1EC4B4':'#C3C4C7'}}
          onClick={() => this.props.onDrillDownClick(this.props.node)}
        >
          DRILL DOWN ONE LEVEL <img src={triangleShape} style={{ marginTop:'-2px'}} />
        </div>
        <div className="leaf-node-error" style={{display:isLeafNode?'block':'none'}}>
          There are no lower level offices in the system. Please select a different office.
        </div>
      </div>
    );
  }
}
 
export default OrgChartNode;